export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11050.ea01bfa3.jpg";